import './activityDetails.css';
import DetailsImageDisplay from '../../components/detailsImageDisplay/DetailsImageDisplay';
import DetailsTabs from '../../components/detailsTabs/DetailsTabs';
import { useContext, useEffect, useRef, useState } from 'react';
import ReactLoading from 'react-loading';
import moment from 'moment';
import ReviewStars from '../../components/reviewStars/ReviewStars';
import { ReactComponent as Share } from '../../assets/icons/trvto_share.svg';
import { share } from './activityDetailsFun/tripDetailsShare';
import fetchTripCheck from './tripCheckFun/tripCheck';
import { userReview } from '../../api/userAPI';
import { UserAuthContext } from '../../context/UserAuthContext';
import { ReactComponent as CloseIcon } from '../../assets/icons/trvto_close.svg';
import EmptyPage from '../../components/empty-page/emptyPage';
import { getFormattedDate } from '../../utils/formatDate';
import { handleWishlistClick } from '../../utils/wishlistHandler';
import { fetchWishlistData } from '../../components/tripCard/getUserWishlist/getUserWishlist';
import { UserLoginSecContext } from '../../context/UserLoginSecContext';
import { ReactComponent as LoveBlack } from '../../assets/icons/trvto_wishlist.svg';
import { ReactComponent as LoveRed } from '../../assets/icons/trvto_favorite.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import TripCard from '../../components/tripCard/TripCard';
import { ReactComponent as RatingStar } from '../../assets/icons/trvto_rating-star.svg';
// import { ReactComponent as LeftArrow } from '../../assets/icons/trvto_left_arrow_icon.svg';
// import { ReactComponent as RightArraow } from '../../assets/icons/trvto_right_arrow_icon.svg';
import { getInterestedTrips, getInterestedTripsOrg } from '../../api/infoAPI';
import { clearBookingStorage } from '../../utils/clearStorage';
import { use } from 'react';
import fetchTripData from './activityDetailsFun/fetchTripData';
import ActivityBookingTab from './activityBookingTab/ActivityBookingTab';
import DetailsTab from '../../components/orgDetails/detailsTab/DetailsTab';
import { ActivitiesBookingTab } from './activityBookingTab/activityBookingTabFun/bookingTab/ActivitiesBookingTab';

export default function ActivityDetails() {
    const isMobile = window.innerWidth < 768;
    const [packData, setPackData] = useState({});
    const [packDates, setPackDates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [popupVisible, setPopupVisible] = useState(true);
    const [userWishlist, setUserWishlist] = useState([]);
    const [checkTrip, setCheckTrip] = useState(false);
    const [userRating, setUserRating] = useState(0);
    const [popupRating, setPopupRating] = useState(userRating);
    const [typeSel, setTypeSel] = useState('act');
    const [comment, setComment] = useState('');
    const [isFavourite, setIsFavourite] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const { isAuthenticated } = useContext(UserAuthContext);
    const location = useLocation();
    const { setLogButton, setLoginSec } = useContext(UserLoginSecContext);
    const packId = useRef(window.location.pathname.split('/')[3]);
    const type = useRef(
        window.location.pathname.split('/')[1] === 'org'
            ? window.location.pathname.split('/')[2]
            : window.location.pathname.split('/')[1]
    );
    const tripStatus = location.state?.tripStatus;

    const [allowedDates, setAllowedDates] = useState([]);
    const navigate = useNavigate();
    const [interestedTrips, setInterestedTrips] = useState([]);
    const { id } = JSON.parse(localStorage.getItem('tempOrg')) || {};
    const USER_IDS = ['686f837afe8ded032c47991a', '6892ebe235b0fc3f961f5146'];
    const userId = localStorage.getItem('userId');
    const context = {
        role: 'user',
        flow: 'activity'
    };

    useEffect(() => {
        clearBookingStorage();
        setTypeSel((prev) => prev);
        fetchTripData('act', packId.current, setLoading, setPackData, setPackDates);
    }, []);

    useEffect(() => {
        if (!isAuthenticated) return;
        fetchWishlistData(typeSel, setUserWishlist);
        fetchTripCheck(type.current, packId.current, setCheckTrip);
    }, [typeSel, isAuthenticated]);

    useEffect(() => {
        // if (userWishlist?.length === 0) return;
        setIsFavourite(userWishlist?.includes(packData._id));
    }, [userWishlist, packData?._id]);

    useEffect(() => {
        if (packDates?.length !== 0) {
            setAllowedDates(
                packDates?.map(function (obj) {
                    return moment(obj.startDate);
                })
            );
        }
    }, [packDates]);

    const handleSubmitRating = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const ratingData = {
            packId: packId.current,
            userName: localStorage.getItem('name'),
            userId: localStorage.getItem('userId'),
            rating: popupRating,
            organizerId: packData.organizerId,
            comment
        };
        await userReview(typeSel, ratingData);
        setUserRating(popupRating);
    };

    const handleWishlist = () => {
        if (isAuthenticated) {
            handleWishlistClick(packData._id, userWishlist, typeSel, setUserWishlist);
        } else {
            setLogButton(true);
            setLoginSec('login');
        }
    };

    // useEffect(() => {
    //     if (!type || !packId) {
    //         return;
    //     }
    //     const fetchIntrestedTrips = async () => {
    //         try {
    //             const result = id
    //                 ? await getInterestedTripsOrg(type.current, id)
    //                 : await getInterestedTrips(type.current, packId.current);
    //             if (result?.data) {
    //                 const tripData = result?.data || [];
    //                 setInterestedTrips(tripData);
    //             }
    //         } catch (error) {
    //             console.error('Error fetching interested trips:', error);
    //         }
    //     };
    //     fetchIntrestedTrips();
    // }, [type, packId, id]);

    const carouselRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const updateScrollButton = () => {
        const el = carouselRef.current;
        if (!el) return;

        const scrollLeft = Math.round(el.scrollLeft);
        const maxScrollLeft = el.scrollWidth - el.clientWidth;

        const canScrollLeftNow = scrollLeft > 0;
        const canScrollRightNow = scrollLeft < maxScrollLeft - 1;

        setCanScrollLeft(canScrollLeftNow);
        setCanScrollRight(canScrollRightNow);
    };

    const scrollLeft = () => {
        const el = carouselRef.current;
        if (!el) return;
        const scrollAmount = el.clientWidth;
        el.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        setTimeout(updateScrollButton, 300);
    };

    const scrollRight = () => {
        const el = carouselRef.current;
        if (!el) return;
        const scrollAmount = el.clientWidth;
        el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        setTimeout(updateScrollButton, 300);
    };

    useEffect(() => {
        const scrollEl = carouselRef.current;
        if (!scrollEl) return;

        const handleUpdate = () => updateScrollButton();

        scrollEl.addEventListener('scroll', handleUpdate);

        // Run after layout to get correct dimensions
        setTimeout(updateScrollButton, 0);

        return () => scrollEl.removeEventListener('scroll', handleUpdate);
    }, [interestedTrips]);

    const baseCities = packData?.quickView?.baseCities;
    const startCityLocation = baseCities && baseCities.split(',');

    const closePopup = () => setPopupVisible(false);

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            {packData && Object.keys(packData)?.length !== 0 ? (
                <>
                    <div className='tripDetailsLayout actDetailsLayout'>
                        <div className='tripDetailsMainRow'>
                            <div className='tripDetailsLeft'>
                                <div className='tripDetailsHeadingDivUser'>
                                    <div className='detailsImageDisplayNameUser'>
                                        <span className='titleTrip'>{packData?.title || 'N/A'}</span>
                                        <div className='icons'>
                                            {isFavourite ? (
                                                <LoveRed className='wishlist-icon-trip-user' onClick={handleWishlist} />
                                            ) : (
                                                <LoveBlack
                                                    className='wishlist-icon-trip-user'
                                                    onClick={handleWishlist}
                                                />
                                            )}
                                            <Share className='share-icon-trip-user' onClick={(e) => share(e)} />
                                        </div>

                                        {/* <button className='addToWishlistButton' onClick={handleWishlist}>
                                                       {isFavourite ? 'Remove from' : 'Add to'} Wishlist
                                                   </button> */}
                                    </div>
                                    <div>
                                        <div className='tripBriefInfo'>
                                            {/* {USER_IDS.includes(userId) && (
                                                                   <>
                                                                       <span
                                                                           className='tripDetailsSubDetails'
                                                                           style={{ fontSize: 'small' }}
                                                                       >
                                                                           By
                                                                       </span>
                                                                       <span
                                                                           className='tripDetailsSubDetails'
                                                                           // onClick={() => {
                                                                           //     navigate(`/h/orgid/${packData?.organizerId}`);
                                                                           // }}
                                                                       >
                                                                           {packData?.organizerName}
                                                                       </span>
                                                                       <span className='tripDetailsDot'></span>
                                                                   </>
                                                               )} */}
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.duration}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span
                                                className='tripDetailsSubDetails'
                                                style={{ textTransform: 'capitalize' }}
                                            >
                                                {packData.datesType}
                                            </span>

                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                At: {packData?.quickView?.baseCities}
                                            </span>

                                            {/* <span className='tripDetailsDot'></span>
                                               <span className='tripDetailsSubDetails'>{packData?.quickView?.startTime}</span>
                                               <span className='tripDetailsDot'></span>
                                               <span className='tripDetailsSubDetails'>{packData?.quickView?.stay}</span>
                                               <span className='tripDetailsDot'></span>
                                               <span className='tripDetailsSubDetails'>{packData?.quickView?.food}</span>
                                               <span className='tripDetailsDot'></span>
                                               <span className='tripDetailsSubDetails'>{packData?.quickView?.type[0]}</span>
                                               <span className='tripDetailsDot'></span>
                                               <span className='tripDetailsSubDetails'>{packData?.quickView?.difficulty}</span>
                                               <span className='tripDetailsDot'></span> */}

                                            <span
                                                className='tripRatings'
                                                style={{ display: 'flex', alignItems: 'center' }}
                                            >
                                                {/* <ReviewStars rating={packData?.rating || 0} /> */}
                                                <RatingStar style={{ marginRight: '4px' }} />
                                                <span>{packData?.rating || 0}</span>
                                                {/* <p style={{ margin: 0 }}>({packData?.reviewCount || 0} Reviews)</p> */}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <DetailsImageDisplay imageData={packData.images} videoData={packData.videos} />
                                {/* <DetailsTabs
                                                   tripDetailsData={packData}
                                                   isExpanded={isExpanded}
                                                   setIsExpanded={setIsExpanded}
                                                   typeSel={typeSel}
                                                   packDates={packDates}
                                               /> */}
                                <DetailsTab context={context} data={packData} type='act' />
                            </div>
                            <div className='tripDetailsBookingUser'>
                                <ActivityBookingTab
                                    packData={packData}
                                    setPackData={setPackData}
                                    allowedDates={allowedDates}
                                    packDates={packDates}
                                    setPackDates={setPackDates}
                                    setLoading={setLoading}
                                    isExpanded={isExpanded}
                                    setIsExpanded={setIsExpanded}
                                />
                            </div>
                        </div>
                        {interestedTrips && interestedTrips.length > 0 && !isMobile && (
                            <>
                                <div className='carousel'>
                                    <p className='carousel-header'>You might be interested in</p>
                                </div>
                                <div className='carousel-container'>
                                    {canScrollLeft && (
                                        <button className='modalNavButton left' onClick={scrollLeft}>
                                            ‹
                                        </button>
                                    )}
                                    <div className='searchResultContentAreaTrip' ref={carouselRef}>
                                        <TripCard imageData={interestedTrips} interested={true} type={typeSel} />
                                    </div>
                                    {canScrollRight && (
                                        <button className='modalNavButton right' onClick={scrollRight}>
                                            ›
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                        {isMobile && (
                            <>
                                <div className='carousel'>
                                    <p className='carousel-header'>You might be interested in</p>
                                </div>
                                <div className='carousel-container'>
                                    {canScrollLeft && (
                                        <button className='modalNavButton left' onClick={scrollLeft}>
                                            ‹
                                        </button>
                                    )}
                                    <div className='searchResultContentAreaTrip' ref={carouselRef}>
                                        <TripCard imageData={interestedTrips} interested={true} type={typeSel} />
                                    </div>
                                    {canScrollRight && (
                                        <button className='modalNavButton right' onClick={scrollRight}>
                                            ›
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                        {isAuthenticated &&
                            (tripStatus === 'In Progress' || tripStatus === 'Completed') &&
                            checkTrip?.data?.status &&
                            popupVisible && (
                                <div className='ratingModal'>
                                    <div className='modalContent'>
                                        <div className='ratingHeader'>
                                            <h3>Rate Your Previous Trip</h3>
                                            <CloseIcon onClick={closePopup} className='loginCloseIcon' />
                                        </div>
                                        <ReviewStars
                                            rating={popupRating}
                                            onRatingChange={(newRating) => setPopupRating(newRating)}
                                            isInteractive
                                        />
                                        <textarea
                                            value={comment}
                                            onChange={(e) => setComment(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                            placeholder='Add your comments here...'
                                            className='commentBox'
                                        />
                                        <div className='modalActions'>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleSubmitRating(e);
                                                }}
                                                className='submitRating'
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                </>
            ) : (
                <EmptyPage />
            )}
        </div>
    );
}
